import { Link } from "react-router-dom";
import { Lock, Crown } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { useMeta } from "../../lib/api";

export default function ContactLock({ compact = false }) {
  const { user } = useAuth();
  const meta = useMeta();
  const free = meta?.free_mode;
  const expired = user && user.plan_state === "expired";
  const to = user ? "/plans" : "/login?next=" + encodeURIComponent(window.location.pathname);
  return (
    <div className={`rounded-xl border-2 border-dashed border-[var(--orange)] bg-orange-50 text-center ${compact ? "p-3" : "p-4"}`} data-testid="contact-locked">
      <Lock className="w-6 h-6 mx-auto text-[var(--orange)]" />
      <p className="mt-1 font-display font-bold text-lg text-[var(--navy)]" data-testid="contact-locked-message">
        {free ? "संपर्क पाहण्यासाठी Login करा - मोफत!" : expired ? "प्लॅन संपला - पुन्हा सुरू करा" : "संपर्क पाहण्यासाठी ₹99 भरा"}
      </p>
      <p className="text-xs text-slate-600">{free ? "सध्या सर्व काही मोफत - फक्त मोबाईल नंबरने नोंदणी करा" : user ? "Membership घ्या आणि सर्व संपर्क पहा" : "आधी Login करा, मग Membership घ्या"}</p>
      <Link to={to} className="mt-3 inline-flex items-center gap-1.5 h-11 px-5 rounded-xl bg-[var(--orange)] hover:bg-[#e86e00] text-white font-semibold transition-colors" data-testid="contact-unlock-button">
        <Crown className="w-4 h-4" /> {user ? (expired ? "पुन्हा सुरू करा" : "Plan निवडा") : "Login करा"}
      </Link>
    </div>
  );
}
